import(/* webpackMode: "eager" */ "/vercel/path0/app/service-details/[id]/page.jsx")